import {
	useState,
} from 'react';
import {
	SvgDeviation,
} from 'components/svg/Svg';
import Deviation, {
	getDeviationHeader,
} from './modals/deviations/deviation/Deviation';
import {
	useLiveQuery,
} from 'dexie-react-hooks';
import {
	database,
} from 'utils/database';
import {
	isDone,
} from 'utils/transport';
import {
	Assignment,
	DeviationModel,
} from 'models';


import DeviationList from './modals/deviations/list/DeviationList';
import {
	FieldWithIcon,
} from './fieldWithIcon/FieldWithIcon';

interface Props {
	assignment: Assignment,
}

export const TransportDeviation = ({
	assignment,
}: Props): JSX.Element | null => {
	const deviations = useLiveQuery(() =>
		database.deviations.where('transportId').equals(assignment.id).toArray());

	const [selectedDeviation, setSelectedDeviation] = useState<DeviationModel | undefined>();
	const [showDeviationList, setShowDeviationList] = useState<boolean>(false);

	const isAssignmentDone = isDone(assignment);

	/**
	 * When there's registered one deviation to the transport, this will be opened. When
	 * there's registered more than one deviation to the transport, a modal with a list of
	 * deviations will be shown.
	 */
	const onClick = () => {
		if (deviations) {
			if (deviations.length === 1) {
				setSelectedDeviation(deviations[0]);
			}

			else { /* More than one deviation; user will need to select which */
				setShowDeviationList(true);
			}
		}
	};

	if (deviations?.length) {
		return (
			<>
				{deviations?.map((deviation, index) => (
					<FieldWithIcon
						key={deviation.id}
						header="Avvik"
						icon={<SvgDeviation
							className="transport-deviation-icon"
							done={isAssignmentDone}
							alt={`${getDeviationHeader(deviation.code)}: ${deviation.comment}`}
						/>}
						description={getDeviationHeader(deviation.code)}
						onClick={index === 0 ? onClick : undefined}
					/>
				))}


				{deviations && showDeviationList && (
					<DeviationList
						deviations={deviations}
						onClose={() => {
							setShowDeviationList(false);
						}}
						onChange={(deviation) => {
							setShowDeviationList(false);
							setSelectedDeviation(deviations.find(d => d.id === deviation.id));
						}}
					/>
				)}

				{selectedDeviation && selectedDeviation.code &&
					<Deviation
						code={selectedDeviation.code}
						show={!!selectedDeviation}
						setShow={() => setSelectedDeviation(undefined)}
						onClose={() => setSelectedDeviation(undefined)}
						assignment={assignment}
						deviation={selectedDeviation}
						setHideAllModals={() => setSelectedDeviation(undefined)}
					/>
				}
			</>
		);
	}

	return null;
};